import React, { Component } from 'react';
import PropTypes from 'prop-types';

import FullScreenView from 'common/components/FullScreenView';
import IFrame from 'common/components/IFrame';

const VIEWING_TITLE = 'Viewing';

export default class EventPreview extends Component {
    static propTypes = {
        eventName: PropTypes.string.isRequired,
        eventUrl: PropTypes.string.isRequired,
        actions: PropTypes.arrayOf(PropTypes.node),
        onRequestClose: PropTypes.func.isRequired,
    };

    static defaultProps = {
        actions: [],
    };

    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
        };
    }

    onIframeLoaded = () => {
        this.setState({ isLoading: false });
    };

    handleClosePreview = () => {
        this.props.onRequestClose();
    };

    render() {
        const { isLoading } = this.state;
        const { eventName, eventUrl, actions, ...props } = this.props;

        return (
            <FullScreenView
                open
                title={`${VIEWING_TITLE} ${eventName}`}
                actions={actions}
                onRequestClose={this.handleClosePreview}
                isLoading={isLoading}
                {...props}
            >
                <IFrame url={`${eventUrl}`} onIframeLoaded={this.onIframeLoaded} />
            </FullScreenView>
        );
    }
}
